import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { useDispatch, useSelector } from 'react-redux';
import { cancelEvent, updateEvent } from '../../../../actions/calendar';

const ActionsEvents = (props) => {
  const { event, reloadData } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openModal, setOpenModal] = React.useState(false);
  const open = Boolean(anchorEl);
  const { sending, messageAction, error } = useSelector((state) => state.tasks);

  const dispatch = useDispatch();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    reloadData();
  };

  const finishEventAction = () => {
    dispatch(cancelEvent(event.id));
    reloadData();
    setAnchorEl(null);
  };

  const updateEventLocal = () => {
    dispatch(updateEvent(event.id, { hasVisit: true }));
    reloadData();
    setAnchorEl(null);
  };

  // const closeModal = () => {
  //   setOpenModal(false);
  //   setAnchorEl(null);
  // };

  return (
    <div>
      <IconButton
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            width: 200,
          },
        }}
      >
        <MenuItem onClick={updateEventLocal}>Cita Realizada</MenuItem>
        <MenuItem onClick={finishEventAction}>Cita Cancelada</MenuItem>
      </Menu>
    </div>
  );
};

export default ActionsEvents;
